import { payMoveInEndPoint, payReserveEndPoint } from '../../../helpers/config';
import { DynamicFormTypes } from '../DynamicFormTypes';
import { getFieldsData, getTitlename } from './GenericFormHelper';
import {
  frameRentalInfoResForPayment,
  frameRequestForRentalInfo,
} from '../../confirmation/helpers/ConfirmationSectionHelpers';
import { errorUrl } from './config';
import { getPathName } from '../../../helpers/paymentComponentHelper';
import { tenantCreationHelper } from './apiHelpers';
import { format } from 'date-fns';
import { getCookies, setNewTenantCookie } from './cookiesHelper';
import { getGlobalAndFacilityEncKeyFromContext } from '../../../../../utilities/encKeyHelpers';
import { fetchRentalInfo } from '@codeparva/v11-tfw-api-library';

export const FrameConfigs = (gatsbyPathName: string, ledgerID: string) => {
  if (gatsbyPathName.includes('reserve')) {
    return {
      url: {
        reservation: payReserveEndPoint,
      },
      total_amount: '',
      isReservation: gatsbyPathName.includes('reserve'),
      isMoveIn: gatsbyPathName.includes('move-in'),
      data: {
        ledger_id: ledgerID || '',
      },
      reservation: {},
    };
  } else {
    return {
      url: {
        movein: payMoveInEndPoint,
      },
      total_amount: '',
      isReservation: gatsbyPathName.includes('reserve'),
      isMoveIn: gatsbyPathName.includes('move-in'),
      data: {
        ledger_id: ledgerID || '',
      },
      move_in: {},
    };
  }
};

export const frameConfirmationConfig = (
  res: DynamicFormTypes.TConfirmationConfig,
  confirmationConfig: any,
  gatsbyPathName: string,
  arrayData: {
    key: string;
    label: string;
    value: any;
  }[]
) => {
  for (let key in res) {
    if (
      Object.keys(res[key as keyof DynamicFormTypes.TUpdatedFormData]).length >
      0
    ) {
      key === 'moveInDetails'
        ? confirmationConfig.sections.push({
            title: 'Move-In Details',
            fields: [
              {
                key: 'moveInDetails',
                label: 'Move-In Date',
                value: res['moveInDetails']['Move-In Date'],
              },
              gatsbyPathName.includes('move-in')
                ? {
                    key: 'moveInDetails',
                    label: 'Billing Cycle',
                    value: 'Monthly',
                  }
                : {
                    key: 'moveInDetails',
                    label: '',
                    value: '',
                  },
            ],
          })
        : confirmationConfig.sections.push({
            title: getTitlename(
              key,
              res[key as keyof DynamicFormTypes.TUpdatedFormData]
            ),
            fields: getFieldsData(
              key,
              res[key as keyof DynamicFormTypes.TUpdatedFormData],
              arrayData
            ),
          });
    }
  }
};

export const MoveInReservationAPIHelper = async ({
  setShowError,
  TenantInfo_DriverLicenseNumber,
  tenantCreateRequest,
  errors,
  setErrors,
  individualUnitDataContext,
  TenantInfo_DesiredMoveInDate = new Date(),
  gatsbyPathName,
  setPaymentComponentReq,
  tenantUserName,
  tenantUserPassword,
  facilityID,
  ledgerInfo,
  pathName,
  tenantId,
  values,
  globalContext,
  sessionTimerContext,
  setIsAccountCreated,
  ledgerIdFromReservation,
  reservationId,
  facilityContext,
}: DynamicFormTypes.TMoveInReservationHelper) => {
  const { globalEncKey, facPublicKey } = getGlobalAndFacilityEncKeyFromContext(
    facilityContext,
    facilityID
  );
  const tenantToken = globalContext?.token || getCookies('cToken');

  try {
    setShowError(false);
    const [err, res] = await tenantCreationHelper(
      TenantInfo_DriverLicenseNumber,
      globalEncKey,
      tenantCreateRequest,
      ledgerInfo,
      facilityID,
      tenantId,
      setShowError,
      setErrors,
      values,
      globalContext,
      sessionTimerContext,
      setIsAccountCreated,
      ledgerIdFromReservation,
      facPublicKey
    );
    if (err) {
      setShowError(true);
      const url = getPathName(pathName, errorUrl);
      {
        window.history.pushState({}, '', `${url}/${errorUrl}`);
      }
      setErrors(prevState => [...prevState, err]);
    } else {
      setShowError(false);
      const { TenantInfo_EmailAddress, OtherInfo_NewPassword = '' } = values;
      const tenantEmail =
        tenantUserName !== '' ? tenantUserName : TenantInfo_EmailAddress;
      const tenantPassword =
        tenantUserPassword !== '' ? tenantUserPassword : OtherInfo_NewPassword;
      const { data: [{ ledger, id }] = [] } = res?.data;
      let ledgerIdFromSMS = ledgerIdFromReservation || ledger[0].id || '';
      if (!ledgerIdFromReservation && ledgerIdFromSMS)
        setNewTenantCookie(ledgerIdFromSMS);

      const { unitTypeID } = individualUnitDataContext;
      const { selectedPromoPlanId } = globalContext || {};
      const promoPlanData = selectedPromoPlanId
        ? { promo_plan_ids: [selectedPromoPlanId] }
        : {};
      const rentalInfoReq: any = await frameRequestForRentalInfo(
        format(new Date(TenantInfo_DesiredMoveInDate), 'yyyy-MM-dd'),
        ledgerIdFromSMS,
        unitTypeID,
        gatsbyPathName,
        promoPlanData
      );

      const [
        rentalInfoReqErr,
        { data: { data: rentalInfoData = {} } = {} } = {},
      ] = await fetchRentalInfo({
        rentalInfoReq,
        facilityId: facilityID,
        tenantToken,
        facPublicKey,
      });
      if (rentalInfoReqErr) {
        console.error(errors[0]);
        setShowError(true);
        setErrors(prevState => [...prevState, rentalInfoReqErr]);
        return {
          rentalInfoSuccess: false,
        };
      }

      setShowError(false);
      const updatedRentalInfoRes = frameRentalInfoResForPayment(
        rentalInfoData,
        format(new Date(TenantInfo_DesiredMoveInDate), 'yyyy-MM-dd'),
        gatsbyPathName,
        unitTypeID,
        ledgerIdFromSMS,
        reservationId,
        promoPlanData
      );
      setPaymentComponentReq(updatedRentalInfoRes);
      return {
        ledgerIdFromSMS,
        tenantEmail,
        tenantPassword,
        updatedRentalInfoRes,
        tenantIdFromCreationAPI: id || '',
        rentalInfoSuccess: true,
      };
    }
  } catch (err) {
    console.error('Error in MoveInReservationAPIHelper', err);
  }
};
